// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media-wrapper>div[data-v-f15d121c]{position:absolute;top:0;bottom:0;left:0;right:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
